import { iif, MonoTypeOperatorFunction, of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';

export const TRIES = 15;
export const DELAY = 1000; // time in miliseconds

export function waitForIndex<T>(tries?: number, delayInMilliseconds?: number): MonoTypeOperatorFunction<T> {
    const triesInner = tries || TRIES;
    const delayInner = delayInMilliseconds || DELAY;

    return retryWhen(errors =>
        errors.pipe(
            concatMap((error, index) =>
                iif(() => index > triesInner, throwError(error), of(error).pipe(delay(delayInner)))
            )
        )
    );
}
